import { RGradientMarker } from "maplibre-react-components";
import { useMutateGtfsStop, useQueryGtfsResource } from "../../Queries";
import { useContext } from "react";
import { mainToolset, ToolsContext, ToolsDispatchContext } from "../../ToolsContext";



export function StopsMl() {
    const {data, isPending, error} = useQueryGtfsResource('stops');
    const tool = useContext(ToolsContext);
    const toolDispatch = useContext(ToolsDispatchContext);
    const mutateStop = useMutateGtfsStop();

    if (!data || isPending || error) return null;

    const handleClick = (e, GStop) => {

        /* Zaznaczanie w trybie odcinków */
        if(tool.name === 'segmentsTool') {
            const newSelection = {
                ...tool.selection
            }
            
            if (!newSelection.from_stop_id && !newSelection.to_stop_id) {
              newSelection.from_stop_id = GStop.stop_id;
            } else if (newSelection.from_stop_id && !newSelection.to_stop_id) {
              newSelection.to_stop_id = GStop.stop_id;
            } else {
              newSelection.from_stop_id = GStop.stop_id;
              newSelection.to_stop_id = null;
            }

            toolDispatch({
              type: 'changed',
              newTool: {
                ...tool,
                selection: newSelection
              },
          }); 
          
          return;
        }

        /** Normalne zaznaczanie */
        toolDispatch({
            type: 'changed',
            newTool: {
              ...mainToolset.tools.stopsTool,
              selection: GStop.stop_id, // zaznacz przystanek na mapie
              propertyEditor: {
                edit: GStop,
                popup: true
              }
            },
        });
    }  

    const markerColor = (GStop) => {
      if (tool.name === "segmentsTool") {
        if (!tool.selection) return "#0000ff"; // normalny
        if (tool.selection.from_stop_id == GStop.stop_id) return "#00ff00"; // zielony
        if (tool.selection.to_stop_id == GStop.stop_id) return "#ff0000"; // czerwony
        return "#0000ff" // normalny
      }

      return (tool.selection === GStop.stop_id) ? "#ffff00" : "#0000ff" // żółty lub niebieski
    }

    const Markers = Object.entries(data).map(([, GStop]) => {
        //key = (tool.selection === GStop.stop_id) ? GStop.stop_id + 'sel' : GStop.stop_id;
        return <RGradientMarker
            draggable={(tool.selection === GStop.stop_id)}
            key={GStop.stop_id}
            latitude={GStop.stop_lat}
            longitude={GStop.stop_lon}
            color={ markerColor(GStop) }
            scale={0.75}
            clickTolerance={10}
            onClick={(e) => handleClick(e, GStop)}
            onContextMenu={(e) => console.log('markermeni',e)}
            onDragEnd={(e) => {
                const ll = e.target._lngLat;
                const data = {
                  query: {
                    modified_stop_id: GStop.stop_id
                  },
                  fields: {
                    stop_lat: ll.lat,
                    stop_lon: ll.lng
                  }
                };
                mutateStop.mutate(data);
            }}
        />
    })

    return (
        <>{Markers}</>
    )

}
